import React, { memo } from 'react';
import WebsiteFilters from 'components/filters/WebsiteFilters';

export const HomepageSlidersFilters = memo(
  ({
    onFiltersChange,
    shoppingCenters = [],
    companies = [],
    categories = [],
    loadingCompanies = false,
    filters = {},
  }) => {
    return (
      <WebsiteFilters
        shoppingCenters={shoppingCenters}
        companies={companies}
        categories={categories}
        onFiltersChange={onFiltersChange}
        loading={loadingCompanies}
        showInsegna={false}
        showCategorie={false}
        enableSorting={true}
      />
    );
  },
);
